import { Box } from '@mui/material';

import { AnalyticsButton } from 'components/AnalyticsButton';
import { useImpersonation } from 'hooks/impersonation';
import { useAuth } from 'shared/lib/auth/useAuth';
import { StorageKeys } from 'shared/lib/storage/storageService';

export function ImpersonationBar() {
  const { isAuthenticated } = useAuth();

  const { [StorageKeys.IMPERSONATION_EMAIL]: impersonationEmail, stopImpersonation } = useImpersonation();

  const isShown = Boolean(impersonationEmail) && isAuthenticated;

  if (!isShown) {
    return <></>;
  }

  return (
    <Box className="absolute z-[1000] text-center" width={1}>
      <Box className="ml-auto flex w-fit items-center rounded-bl-lg bg-[#ffc6c6] px-4">
        You are logged in as {impersonationEmail}
        <AnalyticsButton color="inherit" eventName="impersonation bar - click stop" onClick={() => stopImpersonation()}>
          Stop
        </AnalyticsButton>
      </Box>
    </Box>
  );
}
